module.exports = __webpack_public_path__ + "static/media/webpublication.1f77029a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/webpublication.svg
// module id = 664
// module chunks = 0